import * as React from 'react';

function IconStatusErrorSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8 2C6.81331 2 5.65327 2.35189 4.66658 3.01118C3.67988 3.67047 2.91085 4.60754 2.45672 5.7039C2.0026 6.80026 1.88378 8.00666 2.11529 9.17054C2.3468 10.3344 2.91824 11.4035 3.75736 12.2426C4.59647 13.0818 5.66557 13.6532 6.82946 13.8847C7.99334 14.1162 9.19974 13.9974 10.2961 13.5433C11.3925 13.0892 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM8 12C7.20887 12 6.43551 11.7654 5.77772 11.3259C5.11992 10.8864 4.60723 10.2616 4.30448 9.53073C4.00173 8.79983 3.92252 7.99556 4.07686 7.21964C4.2312 6.44371 4.61216 5.73098 5.17157 5.17157C5.73098 4.61216 6.44371 4.2312 7.21964 4.07686C7.99556 3.92252 8.79983 4.00173 9.53073 4.30448C10.2616 4.60723 10.8864 5.11992 11.3259 5.77772C11.7654 6.43552 12 7.20887 12 8C12 9.06087 11.5786 10.0783 10.8284 10.8284C10.0783 11.5786 9.06086 12 8 12Z"
        fill="currentColor"
      />
      <path
        d="M9.29 5.29L8 6.59L6.71 5.29L5.29 6.71L6.59 8L5.29 9.29L6.71 10.71L8 9.41L9.29 10.71L10.71 9.29L9.41 8L10.71 6.71L9.29 5.29Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusErrorSmall;
